import { PolarAngleAxis, PolarGrid, PolarRadiusAxis, Radar, RadarChart, ResponsiveContainer } from 'recharts';

export interface NngHeuristic {
  id: string;
  name: string;
  score: number;
}

const SHORT_LABEL: Record<string, string> = {
  h1_visibility: 'Visibility',
  h2_match: 'Match',
  h3_user_control: 'Control',
  h4_consistency: 'Consistency',
  h5_error_prevention: 'Error prev.',
  h6_recognition: 'Recognition',
  h7_flexibility: 'Flexibility',
  h8_aesthetic: 'Aesthetic',
  h9_recover: 'Recovery',
  h10_help: 'Help',
};

export function NngRadar({ heuristics }: { heuristics: NngHeuristic[] }) {
  const data = heuristics.map((h) => ({
    label: SHORT_LABEL[h.id] ?? h.id,
    score: h.score,
  }));
  return (
    <ResponsiveContainer width="100%" height={320}>
      <RadarChart data={data} outerRadius="75%">
        <PolarGrid stroke="oklch(0.30 0.02 250)" />
        <PolarAngleAxis dataKey="label" tick={{ fill: 'oklch(0.65 0.02 250)', fontSize: 11 }} />
        <PolarRadiusAxis angle={90} domain={[0, 100]} tick={{ fill: 'oklch(0.55 0.02 250)', fontSize: 9 }} />
        <Radar
          dataKey="score"
          stroke="oklch(0.72 0.15 195)"
          fill="oklch(0.72 0.15 195)"
          fillOpacity={0.4}
        />
      </RadarChart>
    </ResponsiveContainer>
  );
}
